import styled from '@themes/theme'

export const GeneralPopupTit = styled.div`
  .title {
    display: inline-block;
  }
`
